package org.btmonier.games.model

import kotlinx.serialization.Serializable

@Serializable
data class GameList(
    val games: List<Game>
)
